// extracted by mini-css-extract-plugin
module.exports = {"homePage":"containers-Dashboard-TasksAndChecklist-BookingHomePage__homePage--21v8Q","mainText":"containers-Dashboard-TasksAndChecklist-BookingHomePage__mainText--3ofta"};